import Headroom from "headroom.js";

export class Header {

    baseOptions = {
        offset: {
            down: 110,
            up: 0
        }
    };

    constructor() {
        const headroomElement = document.querySelector('div.headroom-wrapper');
        if (headroomElement) {
            const options = this.getOptions();

            const headroom = new Headroom(headroomElement, options);
            window.headroom = headroom;
            headroom.init();
        }
    }

    getOptions() {

        const hasArticleAside = !!document.querySelector('aside.article-page__aside');
        const hasStickyContactButton = !!document.querySelector('.expandable-contact-button');

        const hasDetailedCheckoutSum = !!document.querySelector('.detailed-cart-sum');
        const marginsInPixels = 32;

        if (hasStickyContactButton) {
            return {
                ...this.baseOptions,
                onPin: this.onPinContactButton,
                onUnpin: this.onUnpinContactButton
            }
        }

        if (hasArticleAside || hasDetailedCheckoutSum) {
            return {
                ...this.baseOptions,
                onPin: () => this.onPin(marginsInPixels),
                onUnpin: () => this.onUnpin(marginsInPixels)
            }
        }

        return {
            ...this.baseOptions
        };
    }

    onUnpin(marginsInPixels) {
        const asideContainer = document.querySelector('.article-page__aside-content');
        const detailedCheckoutSum = document.querySelector('.detailed-cart-sum');
        const windowHeight = window.innerHeight;

        if (asideContainer) {
            asideContainer.style.top = null;
            const containerHeight = asideContainer.offsetHeight;

            if (containerHeight > windowHeight) {
                const negativeOverflow = (-Math.abs(containerHeight - windowHeight)) - marginsInPixels;
                asideContainer.style.top = `${negativeOverflow}px`;
            }
        }

        if (detailedCheckoutSum) {
            detailedCheckoutSum.style.top = null;
            if (detailedCheckoutSum.offsetHeight > windowHeight) {
                const negativeOverflow = (-Math.abs(detailedCheckoutSum.offsetHeight - windowHeight)) - marginsInPixels;
                detailedCheckoutSum.style.top = `${negativeOverflow}px`;
            }
        }
    }


    onPin(marginsInPixels) {
        console.log('pin');
        const headroomElement = document.querySelector('.headroom-wrapper');
        const asideElement = document.querySelector('.article-page__aside');
        const asideContainer = document.querySelector('.article-page__aside-content');
        const detailedCheckoutSum = document.querySelector('.detailed-cart-sum');

        if (headroomElement) {
            const topPosition = headroomElement.offsetHeight + marginsInPixels;

            if (asideElement) {
                const rect = asideElement.getBoundingClientRect();

                // Detect when the top of the aside element is not on screen
                const asideIsScrolledDown = rect.top < 0;

                // Adjust positioning if scrolled down
                if (asideIsScrolledDown) {
                    asideElement.style.top = `${topPosition}px`;
                }
            }

            if (asideContainer) {
                asideContainer.style.top = `${topPosition}px`;
            }

            if (detailedCheckoutSum) {
                detailedCheckoutSum.style.top = `${topPosition}px`;
            }
        }
    }


    onUnpinContactButton() {
        const contactButton = document.querySelector('.expandable-contact-button');
        const headroomElement = document.querySelector('.headroom-wrapper');
        const headRoomHeight = headroomElement.offsetHeight;
        const topViaCss = parseInt(window.getComputedStyle(contactButton).top, 10);

        const top = topViaCss - headRoomHeight;
        contactButton.style.top = `${top}px`;
    }

    onPinContactButton() {
        const contactButton = document.querySelector('.expandable-contact-button');
        contactButton.style.top = null;
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new Header();
});